import { BOOKADD, BOOKLEADED, DELETEBOOK, EDIT } from "./actionTypes";
import { initialState } from "./initialState";

const booksReducer = (state = initialState, action) => {
 switch (action.type) {
  case BOOKLEADED:
   return [...action.payload];
  case BOOKADD:
   return [...state, action.payload];
  case DELETEBOOK:
   return state.filter((book) => book.id !== action.payload);
  case EDIT:
   const copied = [...state];
   const index = copied.findIndex((book) => book.id === action.payload.id);
   copied[index] = action.payload;
   return copied;
  default:
   return state;
 }
};

export default booksReducer;
